import React from 'react';

const CBCircularProgress = ({ size = 40, strokeWidth = 4, percent = 0, status = 'normal', className = '', trackClassName = 'text-gray-300', progressClassName = 'text-blue-600', textClassName = 'text-xs font-semibold fill-current text-gray-700' }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  // Ensure percent is within 0-100
  const validPercent = Math.max(0, Math.min(100, percent));
  const offset = circumference - (validPercent / 100) * circumference;
  // Determine progress color based on status
  const currentProgressClass = status === 'exception' ? 'text-red-600' : progressClassName;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={`transform -rotate-90 ${className}`} // Rotate to start from the top
    >
      {/* Background Circle */}
      <circle
        stroke="currentColor" // Use text color for the track
        className={trackClassName}
        fill="transparent"
        strokeWidth={strokeWidth}
        r={radius}
        cx={size / 2}
        cy={size / 2}
      />
      {/* Progress Circle */}
      <circle
        stroke="currentColor" // Use text color for the progress
        className={currentProgressClass} // Use status-dependent class
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round" // Make the ends rounded
        r={radius}
        cx={size / 2}
        cy={size / 2}
      />
      {/* Conditional Content: Percentage Text or Exception Icon */}
      {status === 'exception' ? (
        // Red X Icon for exception status
        <g transform={`rotate(90 ${size / 2} ${size / 2})`}> {/* Counter-rotate the group */}
          <line
            x1={size * 0.3} y1={size * 0.3}
            x2={size * 0.7} y2={size * 0.7}
            stroke="currentColor"
            className="text-red-600"
            strokeWidth={strokeWidth * 0.75} // Slightly thinner than the circle stroke
            strokeLinecap="round"
          />
          <line
            x1={size * 0.7} y1={size * 0.3}
            x2={size * 0.3} y2={size * 0.7}
            stroke="currentColor"
            className="text-red-600"
            strokeWidth={strokeWidth * 0.75}
            strokeLinecap="round"
          />
        </g>
      ) : (
        // Percentage Text for normal status
        <text
          x="50%"
          y="50%"
          dy=".3em" // Vertically center
          textAnchor="middle" // Horizontally center
          className={`${textClassName} transform rotate-90 origin-center`} // Rotate text back
        >
          {`${Math.round(validPercent)}%`}
        </text>
      )}
    </svg>
  );
};

export default CBCircularProgress;